/*
 * Single source of truth for whether MFA is mandatory for this account — driven entirely
 * by Member Hub now, not a client-side Split.io flag (see the deleted
 * use-mfa-optional-flag.js). `force_MFA` is a root-level boolean on the /profile response.
 *
 * Fails closed to false (not mandatory-skip-hidden) when the field is missing or the
 * profile hasn't loaded — matches this app's existing "unknown/absent flag never grants an
 * enforcement exemption" convention, just phrased for a synchronous read instead of an
 * async flag fetch: no `force_MFA` means enrolment still offers skip, which is the
 * pre-existing default behaviour this composable's callers had before force_MFA existed.
 */
export default function useForceMfaFlag () {
  const userStore = useUserStore()
  return computed(() => !!userStore.getUserProfile?.force_MFA)
}
